import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'
import { FIREBASE_CONFIG, FIREBASE_VAPID_KEY } from '@/constants'

const firebaseApp = initializeApp(FIREBASE_CONFIG)

const getMessagingInstance = () => isSupported().then(supported => supported ? getMessaging(firebaseApp) : null)

let cachedToken = null

// resolves the FCM device token to send as `fcmToken` on login/refreshToken - asks for
// notification permission once, then reuses the same token for later calls this session
export function requestFcmToken () {
	if (cachedToken) return Promise.resolve(cachedToken)
	if (!('serviceWorker' in navigator)) {
		console.warn('[fcm] skipped: no serviceWorker support in this browser')
		return Promise.resolve(null)
	}

	return getMessagingInstance().then((messaging) => {
		if (!messaging) {
			console.warn('[fcm] skipped: Firebase Messaging not supported in this context (needs HTTPS or localhost)')
			return null
		}
		console.info('[fcm] current permission before request:', Notification.permission)
		return Notification.requestPermission().then((permission) => {
			console.info('[fcm] permission result:', permission)
			if (permission !== 'granted') return null
			return navigator.serviceWorker.getRegistration().then((registration) => {
				return getToken(messaging, {
					vapidKey: FIREBASE_VAPID_KEY,
					...(registration ? { serviceWorkerRegistration: registration } : {})
				})
			}).then((token) => {
				console.info('[fcm] token obtained:', token)
				cachedToken = token
				return token
			})
		})
	}).catch((error) => {
		console.error('[fcm] failed to obtain token:', error)
		return null
	})
}

// foreground push handler - background pushes are handled in src/service-worker.js
export function onForegroundMessage (callback) {
	getMessagingInstance().then((messaging) => {
		if (messaging) onMessage(messaging, callback)
	})
}
